<template>
  <main class="main configurations">
    <div class="white-panel">
      <header class="panel-header space-between">
        <h2 class="panel-title">
          {{ $t('tickets.on.hold') }}
        </h2>
      </header>
      <div
        class="config-panel panel-scroll"
      >
        <!-- List existing tickets -->
        <div v-if="pausedTickets && pausedTickets.length > 0">
          <div
            v-for="ticket in pausedTickets"
            :key="ticket.id"
            class="row config-queue space-between"
          >
            <!-- Data and state for a queue -->
            <div class="queue-data paused">
              <div class="ticket-number">
                {{ ticket.letter }} {{ ticket.number }}
              </div>
              <div class="ticket-user-id">
                <span>{{ ticket.assignedTo }}</span>
              </div>
            </div>
            <!-- <div>
              Atendido por:
            </div> -->
            <button
              class="btn-primary"
              @click="retakeTicket(ticket)"
            >
              {{ $t('retake.ticket') }}
            </button>
          </div>
        </div>
        <div
          v-else
          class="empty-state-container"
        >
          <div class="empty-state">
            <div class="empty-state__content">
              <div class="empty-state__illustration">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="63"
                  height="68"
                >
                  <g
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g opacity=".95999998">
                      <path
                        stroke="#8F94A1"
                        stroke-width="2.4"
                        d="M45.46404003 11.95448934c-.40364569.38806894-.76139605.84045576-1.05695738 1.352383-1.61610757 2.79918043-.760887 6.31852104 1.91018858 7.86066725 2.67107566 1.54214625 6.14652428.52311866 7.76263186-2.27606177.25320623-.43856606.44574737-.8948103.5801445-1.35835856l5.91921643 3.5908102c.96847133.58750965 1.29662817 1.83713994.7417701 2.8246807L42.40771889 57.61067868c-.56822517 1.01133167-1.84870908 1.37054046-2.86004083.80231524-.66404245-.37309774-1.07406618-1.076449-1.07154755-1.83812341l.0301606-9.12106789.1187905-35.92414083c.00383585-1.1600246.94733116-2.09730075 2.10735575-2.0934649.38179804.0012625.75603118.10656735 1.08246252.30459238l3.64914016 2.21370006z"
                      />
                      <path
                        fill="#8F95A1"
                        d="M38.9912927 26.30641016l6.20299497 3.58130082c1.27544697.73637965 1.71244745 2.3672874.97606775 3.64273445-.73637965 1.27544697-2.36728743 1.71244732-3.6427344.97606767l-3.38210928-1.9526617-.58737741-.77826447.43315837-5.46917677zM38.19791649 38.13717453l.50636947-.00168085 1.39137694.80331185c.7288268.42078835.97854138 1.3527356.55775298 2.08156249-.428052.7414078-1.35930972 1.0214329-2.12527717.63906164l-.17254328-.08613367-.15767894-3.43612146z"
                      />
                    </g>
                    <g transform="translate(2 2)">
                      <path
                        stroke="#8F94A1"
                        stroke-width="2.4"
                        d="M25.1953345 0h8.7329194c1.4500388 0 2.6255275 1.17548867 2.6255275 2.62552743V61.2902698c0 1.4500387-1.1754887 2.6255274-2.6255275 2.6255274h-8.7329194c-.3916926-3.543415-3.3397712-6.2972595-6.9184438-6.2972595-3.5786726 0-6.5267512 2.7538445-6.9184438 6.2972595H2.62552743C1.17548867 63.9157972 0 62.7403085 0 61.2902698V2.62552743C0 1.17548867 1.17548867 0 2.62552743 0h8.73291947c.3916926 3.54341503 3.3397712 6.29725953 6.9184438 6.29725953 3.5786726 0 6.5267512-2.7538445 6.9184438-6.29725953z"
                      />
                      <path
                        fill="#8F95A1"
                        d="M7.5673613 33.2956685H24.116727c.7989194 0 1.4465715.6476522 1.4465715 1.4465716v.0339487c0 .7989194-.6476521 1.4465715-1.4465715 1.4465715H7.5673613c-.79891939 0-1.44657152-.6476521-1.44657152-1.4465715v-.0339487c0-.7989194.64765213-1.4465716 1.44657152-1.4465716z"
                      />
                      <rect
                        width="15.8420441"
                        height="2.92709174"
                        x="6.12078978"
                        y="38.7839656"
                        fill="#8F95A1"
                        rx="1.46354587"
                      />
                      <path
                        fill="#8F95A1"
                        d="M9.04788152 19.0260963H23.3562997c.547324 0 1.0549978.1427911 1.488641.393993.4336432.2512018.7932559.6108145 1.0444578 1.0444577.2512018.4336433.3939929.941317.3939929 1.4886411 0 .547324-.1427911 1.0549977-.3939929 1.488641-.2512019.4336432-.6108146.7932559-1.0444578 1.0444577-.4336432.2512019-.941317.393993-1.488641.393993H9.04788152c-.54732403 0-1.05499779-.1427911-1.48864101-.393993-.43364322-.2512018-.7932559-.6108145-1.04445778-1.0444577-.25120188-.4336433-.39399295-.941317-.39399295-1.488641 0-.5473241.14279107-1.0549978.39399295-1.4886411.25120188-.4336432.61081456-.7932559 1.04445778-1.0444577.43364322-.2512019.94131698-.393993 1.48864101-.393993z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <div class="empty-state__title">
                <h3>{{ $t('no.tickets.on.hold') }}</h3>
              </div>
              <div class="empty-state__description">
                <p>{{ $t('no.tickets.on.hold.description.p1') }}</p>
                <p>{{ $t('no.tickets.on.hold.description.p2') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import ticketsAPI from '@/api/tickets'
import api from '@/api'

export default {
  filters: {
    zeroPadding: function (value) {
      return String(value).padStart(3, '0')
    }
  },
  props: {
    serviceID: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      pausedTickets: []
    }
  },
  computed: {
    ...mapState(['service', 'currentTickets']),
    ...mapGetters(['sortedServiceQueues']),
    language () {
      return this.$i18n.locale()
    }
  },
  async created () {
    let { tickets } = await api.getPausedTickets({ service: this.serviceID })

    this.pausedTickets = tickets
    await this.fetchCurrentTickets(this.serviceID)
    await this.fetchService(this.serviceID)
  },
  methods: {
    ...mapActions(['fetchService', 'fetchCurrentTickets', 'setCurrentTicket']),
    async retakeTicket (ticket) {
      await ticketsAPI.attendTicket({
        service: this.serviceID,
        queueSlug: ticket.letter,
        ticket: ticket.id
      })
      this.$router.push({
        name: 'ServicePage',
        params: { serviceID: this.serviceID }
      })
    }
  }
}
</script>
<style lang="scss">
.ticket-user-id {
  margin-left: 4rem;
}
.paused .ticket-number {
  font-size: 34px;
  font-weight: 700;
  text-transform: uppercase;
}
</style>
